export default __webpack_public_path__ + "static/media/hidable.ed89a882.less";